<!-- <div class="nb-theme-default"> -->
<!-- <nb-card>
    <nb-card-body> -->
    <div class="resizable-widget" [ngClass]="resizable ? 'active' : 'disabled'" (resized)="onResized($event)">
        <div echarts [autoResize]="autoResize" [options]="options" class="echarts" (chartInit)="onChartInit($event)"></div>
    </div>
    <!-- </nb-card-body>
</nb-card> -->

<!-- </div> -->